import { i18nConfigurationGeneral } from './i18nConfigurationGeneral';
// SSR init options. Translations are supplied as resources from the
// @as-react/translations package, so there is no HTTP backend to configure —
// only the base options plus the set of languages to preload.
const generateBackEndI18nInitOptions = () => (Object.assign(Object.assign({}, i18nConfigurationGeneral), { preload: i18nConfigurationGeneral.supportedLngs }));
export default () => generateBackEndI18nInitOptions();
